import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useBreakpointsContext } from "@air/provider-media-query";
import { useRef } from "react";
import { ContentCollectionActionBarWrapper } from "~/components/ContentCollection/ContentCollectionActionBar";
import { ContentCollectionGalleryView } from "~/components/ContentCollection/ContentCollectionGalleryView";
import { ContentCollectionManageSidebarWrapper } from "~/components/ContentCollection/ContentCollectionManageSidebarWrapper";
import { ContentCollectionMobileActionBar } from "~/components/ContentCollection/ContentCollectionMobileActionBar";
export const ContentCollectionManageView = ()=>{
    const { isAboveMediumScreen } = useBreakpointsContext();
    const mobileScrollElementRef = useRef(null);
    const desktopScrollElementRef = useRef(null);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex size-full flex-col overflow-y-auto md:flex-row md:overflow-y-hidden",
        ref: mobileScrollElementRef,
        children: [
            /*#__PURE__*/ _jsx(ContentCollectionManageSidebarWrapper, {}),
            /*#__PURE__*/ _jsxs("div", {
                className: "w-full py-6 md:overflow-y-auto md:px-3 md:py-0",
                ref: desktopScrollElementRef,
                children: [
                    /*#__PURE__*/ _jsx(ContentCollectionGalleryView, {
                        scrollElementRef: isAboveMediumScreen ? desktopScrollElementRef : mobileScrollElementRef
                    }),
                    isAboveMediumScreen ? /*#__PURE__*/ _jsx(ContentCollectionActionBarWrapper, {}) : /*#__PURE__*/ _jsx(ContentCollectionMobileActionBar, {})
                ]
            })
        ]
    });
};
ContentCollectionManageView.displayName = "ContentCollectionManageView";
